class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 800);

    const facetForm = this.querySelector("form");
    // Chỉ trigger debouncedOnSubmit khi input thay đổi, ngoại trừ các input[type="number"] trong price range
    facetForm.addEventListener("input", (event) => {
      const target = event.target;
      // Nếu là input[type="number"] trong price range thì bỏ qua
      if (
        target.matches('input[type="number"]') ||
        target.matches('input[type="range"]')
      ) {
        return;
      }
      this.debouncedOnSubmit(event);
    });

    const facetWrapper = this.querySelector("#FacetsWrapperDesktop");
    if (facetWrapper) facetWrapper.addEventListener("keyup", onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state
        ? event.state.searchParams
        : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };

    FacetFiltersForm.renderProductPerPage();
    window.addEventListener("popstate", onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll(".js-facet-remove").forEach((element) => {
      element.classList.toggle("disabled", disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById("ProductCount");
    const countContainerDesktop = document.getElementById(
      "ProductCountDesktop"
    );
    const loadingSpinners = document.querySelectorAll(
      ".facets-container .loading__spinner, facet-filters-form .loading__spinner"
    );
    loadingSpinners.forEach((spinner) => spinner.classList.remove("hidden"));
    document
      .getElementById("ProductGridContainer")
      .querySelector(".collection")
      .classList.add("loading");
    if (countContainer) {
      countContainer.classList.add("loading");
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add("loading");
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [
          ...FacetFiltersForm.filterData,
          { html, url },
        ];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        FacetFiltersForm.renderProductPerPage();
        if (typeof initializeScrollAnimationTrigger === "function")
          initializeScrollAnimationTrigger(html.innerHTML);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    FacetFiltersForm.renderProductPerPage();
    if (typeof initializeScrollAnimationTrigger === "function")
      initializeScrollAnimationTrigger(html.innerHTML);
  }

  static renderProductGridContainer(html) {
    document.getElementById("ProductGridContainer").innerHTML = new DOMParser()
      .parseFromString(html, "text/html")
      .getElementById("ProductGridContainer").innerHTML;

    document
      .getElementById("ProductGridContainer")
      .querySelectorAll(".scroll-trigger")
      .forEach((element) => {
        element.classList.add("scroll-trigger--cancel");
      });
  }

  static renderProductCount(html) {
    const count = new DOMParser()
      .parseFromString(html, "text/html")
      .getElementById("ProductCount").innerHTML;
    const container = document.getElementById("ProductCount");
    const containerDesktop = document.getElementById("ProductCountDesktop");
    container.innerHTML = count;
    container.classList.remove("loading");
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove("loading");
    }
    const loadingSpinners = document.querySelectorAll(
      ".facets-container .loading__spinner, facet-filters-form .loading__spinner"
    );
    loadingSpinners.forEach((spinner) => spinner.classList.add("hidden"));
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, "text/html");
    const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll(
      "#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter"
    );
    const facetDetailsElementsFromDom = document.querySelectorAll(
      "#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter"
    );

    // Remove facets that are no longer returned from the server
    Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
      if (
        !Array.from(facetDetailsElementsFromFetch).some(
          ({ id }) => currentElement.id === id
        )
      ) {
        currentElement.remove();
      }
    });

    const matchesId = (element) => {
      const jsFilter = event ? event.target.closest(".js-filter") : undefined;
      return jsFilter ? element.id === jsFilter.id : false;
    };

    const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter(
      (element) => !matchesId(element)
    );
    const countsToRender = Array.from(facetDetailsElementsFromFetch).find(
      matchesId
    );

    facetsToRender.forEach((elementToRender, index) => {
      const currentElement = document.getElementById(elementToRender.id);
      // Element already rendered in the DOM so just update the innerHTML
      if (currentElement) {
        document.getElementById(elementToRender.id).innerHTML =
          elementToRender.innerHTML;
      } else {
        if (index > 0) {
          const { className: previousElementClassName, id: previousElementId } =
            facetsToRender[index - 1];
          // Same facet type (eg horizontal/vertical or drawer/mobile)
          if (elementToRender.className === previousElementClassName) {
            document.getElementById(previousElementId).after(elementToRender);
            return;
          }
        }

        if (elementToRender.parentElement) {
          document
            .querySelector(`#${elementToRender.parentElement.id} .js-filter`)
            .before(elementToRender);
        }
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) {
      const closestJSFilterID = event.target.closest(".js-filter").id;

      if (closestJSFilterID) {
        FacetFiltersForm.renderCounts(
          countsToRender,
          event.target.closest(".js-filter")
        );
        FacetFiltersForm.renderMobileCounts(
          countsToRender,
          document.getElementById(closestJSFilterID)
        );

        const newFacetDetailsElement =
          document.getElementById(closestJSFilterID);
        const newElementSelector = newFacetDetailsElement.classList.contains(
          "mobile-facets__details"
        )
          ? `.mobile-facets__close-button`
          : `.facets__summary`;
        const newElementToActivate =
          newFacetDetailsElement.querySelector(newElementSelector);

        const isTextInput = event.target.getAttribute("type") === "text";

        if (newElementToActivate && !isTextInput) newElementToActivate.focus();
      }
    }
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = [
      ".active-facets-mobile",
      ".active-facets-desktop",
    ];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML =
        activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = [
      ".mobile-facets__open",
      ".mobile-facets__count",
      ".sorting",
    ];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML =
        html.querySelector(selector).innerHTML;
    });

    document
      .getElementById("FacetFiltersFormMobile")
      .closest("menu-drawer")
      .bindEvents();
  }

  static renderCounts(source, target) {
    const targetSummary = target.querySelector(".facets__summary");
    const sourceSummary = source.querySelector(".facets__summary");

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetHeaderElement = target.querySelector(".facets__header");
    const sourceHeaderElement = source.querySelector(".facets__header");

    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }

    const targetWrapElement = target.querySelector(".facets-wrap");
    const sourceWrapElement = source.querySelector(".facets-wrap");

    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(
        target.querySelector("show-more-button .label-show-more.hidden")
      );
      if (isShowingMore) {
        sourceWrapElement
          .querySelectorAll(".facets__item.hidden")
          .forEach((hiddenItem) =>
            hiddenItem.classList.replace("hidden", "show-more-item")
          );
      }

      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }
  }

  static renderMobileCounts(source, target) {
    const targetFacetsList = target.querySelector(".mobile-facets__list");
    const sourceFacetsList = source.querySelector(".mobile-facets__list");

    if (sourceFacetsList && targetFacetsList) {
      targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
    }
  }

  static renderProductPerPage() {
    const selects = document.querySelectorAll('select[name="paginate_by"]');

    selects.forEach((select) => {
      select.addEventListener("change", function (e) {
        const value = e.target.value;

        var data = new URLSearchParams();
        data.append("attributes[pagination]", value);

        fetch("/cart.js", {
          method: "POST",
          body: data,
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
        }).then((response) => response.text());
      });
    });
  }

  static updateURLHash(searchParams) {
    history.pushState(
      { searchParams },
      "",
      `${window.location.pathname}${searchParams && "?".concat(searchParams)}`
    );
  }

  static getSections() {
    return [
      {
        section: document.getElementById("product-grid").dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll(
      "facet-filters-form form"
    );
    if (event.srcElement.className == "mobile-facets__checkbox") {
      const searchParams = this.createSearchParams(
        event.target.closest("form")
      );
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const isMobile =
        event.target.closest("form").id === "FacetFiltersFormMobile";

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (
            form.id === "FacetSortForm" ||
            form.id === "FacetFiltersForm" ||
            form.id === "FacetSortDrawerForm"
          ) {
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === "FacetFiltersFormMobile") {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join("&"), event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf("?") == -1
        ? ""
        : event.currentTarget.href.slice(
            event.currentTarget.href.indexOf("?") + 1
          );
    FacetFiltersForm.renderPage(url);
  }

  static updatePagination(paginationValue) {
    // Update URL with pagination parameter
    const url = new URL(window.location);
    url.searchParams.set("paginate_by", paginationValue);

    // Remove page parameter when changing pagination
    url.searchParams.delete("page");

    // Navigate to new URL
    window.location.href = url.toString();
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define("facet-filters-form", FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.rangeSliderPrice();

    this.querySelectorAll("input").forEach((element) => {
      element.addEventListener("change", this.onRangeChange.bind(this));
    });

    this.setMinAndMaxValues();

    const numberS = this.querySelectorAll("input[type=number]");
    let value1 = numberS[0].value;
    let value2 = numberS[1].value;

    this.updateDisplay(value1, value2);

    const applyButton = this.querySelector(".price-range__apply-button");
    if (applyButton) {
      applyButton.addEventListener("click", this.onApplyButtonClick.bind(this));
    }
  }

  onRangeChange(event) {
    this.setMinAndMaxValues();
    const numberS = this.querySelectorAll("input[type=number]");
    const value1 = numberS[0].value;
    const value2 = numberS[1].value;
    this.updateDisplay(value1, value2);
    this.updatePrice(value1, value2);
  }

  onApplyButtonClick(event) {
    event.preventDefault();
    const numberS = this.querySelectorAll("input[type=number]");
    const value1 = numberS[0].value;
    const value2 = numberS[1].value;

    this.updateDisplay(value1, value2);
    this.updatePrice(value1, value2);

    const form = this.closest("facet-filters-form");
    if (form) {
      form.onSubmitHandler(event);
    }
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll("input");
    const minInput = inputs[0];
    const maxInput = inputs[1];

    if (minInput.value === "") maxInput.setAttribute("min", 0);
    if (maxInput.value === "")
      minInput.setAttribute("max", maxInput.getAttribute("max"));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute("min"));
    const max = Number(input.getAttribute("max"));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }

  rangeSliderPrice() {
    let width;
    if (window.innerWidth > 750) {
      let facetsVerticalBlock = this.closest(
        ".facets-vertical .facets__disclosure-vertical"
      );
      width = facetsVerticalBlock
        ? facetsVerticalBlock.querySelector(".facets__summary").clientWidth
        : this.clientWidth;

    } else {
      let facetsVerticalBlock = this.closest(".mobile-facets__details");

      width = 324;
    }

    let rangeS = this.querySelectorAll("input[type=range]"),
      numberS = this.querySelectorAll("input[type=number]"),
      isFireFox = typeof InstallTrigger !== "undefined",
      lowerSlider = rangeS[0],
      upperSlider = rangeS[1],
      slide = this.querySelector("input[type=range]").max/100 * (22/(width/100));

    lowerSlider.oninput = () => {
      let slide1 = Math.floor(rangeS[0].value),
        slide2 = Math.ceil(rangeS[1].value);

      if (slide1 > slide2 - slide) {
        upperSlider.value = slide1 + slide;
        numberS[1].value = slide1 + slide;

        if (slide2 == upperSlider.max) {
          lowerSlider.value = parseInt(upperSlider.max) - slide;
          numberS[0].value = parseInt(upperSlider.max) - slide;
        }
      }

      numberS[0].value = slide1;
      numberS[1].value = slide2;
      if (!isFireFox) this.updateDisplay(numberS[0].value, numberS[1].value);
      this.updatePrice(slide1, slide2);
    };

    upperSlider.oninput = () => {
      let slide1 = Math.floor(rangeS[0].value),
        slide2 = Math.ceil(rangeS[1].value);

      if (slide2 < slide1 + slide) {
        lowerSlider.value = slide2 - slide;
        numberS[0].value = slide2 - slide;

        if (slide1 == lowerSlider.min) {
          upperSlider.value = slide;
          numberS[1].value = slide;
        }
      }

      numberS[0].value = slide1;
      numberS[1].value = slide2;

      if (!isFireFox) this.updateDisplay(numberS[0].value, numberS[1].value);
      this.updatePrice(slide1, slide2);
    };

    numberS.forEach((element) => {
      element.oninput = () => {
        var number1 = parseFloat(numberS[0].value),
          checkValue1 = number1 != number1,
          number2 = parseFloat(numberS[1].value),
          checkValue2 = number2 != number2;

        if (!checkValue1) {
          rangeS[0].value = number1;
        }

        if (!checkValue2) {
          rangeS[1].value = number2;
        }

        if (number1 > number2) {
          if (!isFireFox) this.updateDisplay(number2, number1);
          this.updatePrice(number2, number1);
        } else {
          if (!isFireFox) this.updateDisplay(number1, number2);
          this.updatePrice(number1, number2);
        }
      };
    });
  }

  updateDisplay(value1, value2) {
    const range = this.querySelector("input[type=range]");
    const priceSlideRangeContainer = this.querySelector(
      ".facets__price--slide"
    );
    const max = range.max;
    let width;
    if (window.innerWidth > 750) {
      let facetsVerticalBlock = this.closest(
        ".facets-vertical .facets__disclosure-vertical"
      );
      width = facetsVerticalBlock
        ? facetsVerticalBlock.querySelector(".facets__summary").clientWidth
        : priceSlideRangeContainer.clientWidth;
    } else {
      let sidebarBlock = this.closest(".mobile-facets__details");
      width = sidebarBlock
        ? this.querySelector(".facets__price--slide").clientWidth
        : this.clientWidth;
    }

    let leftSpace = (parseInt(value1) / parseInt(max)) * width + "px";
    let rightSpace = width - (parseInt(value2) / parseInt(max)) * width + "px";

    priceSlideRangeContainer.style.setProperty("--left-space", leftSpace);
    priceSlideRangeContainer.style.setProperty("--right-space", rightSpace);
  }

  updatePrice(min, max) {
    const currentMin = this.querySelector(".money--current-min");
    const currentMax = this.querySelector(".money--current-max");

    if (currentMin) currentMin.innerHTML = min;
    if (currentMax) currentMax.innerHTML = max;
  }
}

customElements.define("price-range", PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector("a");
    facetLink.setAttribute("role", "button");
    facetLink.addEventListener("click", this.closeFilter.bind(this));
    facetLink.addEventListener("keyup", (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === "SPACE") this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form =
      this.closest("facet-filters-form") ||
      document.querySelector("facet-filters-form");
    form.onActiveFilterClick(event);
  }
}

customElements.define("facet-remove", FacetRemove);

class ViewMode extends HTMLElement {
  constructor() {
    super();
    this.mediaView = this.querySelector("[data-view-as]");
    this.mediaViewMobile = this.querySelector("[data-view-as-mobile]");
    this.init();
    this.onClickModeButton();
  }

  init() {
    const getColByWidth = (col, width, isVertical) => {
      if (isVertical) {
        if (width < 768 && [3, 4, 5].includes(col)) return 2;
        if (width <= 1100 && width >= 768 && [3, 4, 5].includes(col)) return 2;
        if (width < 1300 && width > 1100 && [4, 5].includes(col)) return 3;
        if (width < 1700 && width >= 1300 && col == 5) return 4;
      } else {
        if (width < 768 && [3, 4, 5].includes(col)) return 2;
        if (width < 992 && width >= 768 && [4, 5].includes(col)) return 3;
        if (width < 1600 && width >= 992 && col == 5) return 4;
      }
      return col;
    };

    const updateViewMode = () => {
      if (!this.mediaView || !this.mediaViewMobile) return;
      let viewMode = this.mediaView.querySelector(".icon-mode.active");
      let viewModeMobile =
        this.mediaViewMobile.querySelector(".icon-mode.active");
      let col = parseInt(viewMode?.dataset.col);
      const width = window.innerWidth;
      const isVertical = document.querySelector(".facets-vertical");
      const newCol = getColByWidth(col, width, isVertical);

      if (col !== newCol) {
        viewMode?.classList.remove("active");
        viewModeMobile?.classList.remove("active");
        this.mediaView
          ?.querySelector(`.grid-${newCol}`)
          ?.classList.add("active");
        this.mediaViewMobile
          ?.querySelector(`.grid-${newCol}`)
          ?.classList.add("active");

        document
          .querySelector(`.facets-wrapper .grid-${newCol}`)
          ?.classList.add("active");
        col = newCol;
      }
      this.initViewModeLayout(col);
    };

    window.addEventListener("resize", updateViewMode);

    if (!this.mediaView || !this.mediaViewMobile) return;
    updateViewMode();
  }

  onClickModeButton(event) {
    this.mediaView?.querySelectorAll(".icon-mode").forEach((modeButton) => {
      modeButton.addEventListener(
        "click",
        this.onClickModeButtonHandler.bind(this)
      );
    });

    this.mediaViewMobile
      ?.querySelectorAll(".icon-mode")
      ?.forEach((modeMobileButton) => {
        modeMobileButton.addEventListener(
          "click",
          this.onClickModeButtonMobileHandler.bind(this)
        );
      });
  }

  onClickModeButtonHandler(event) {
    event.preventDefault();

    var buttonElement = event.currentTarget,
      viewMode = this.mediaView.querySelector(".icon-mode.active"),
      column = parseInt(buttonElement.dataset.col);

    if (!buttonElement.classList.contains("active")) {
      viewMode?.classList.remove("active");
      buttonElement.classList.add("active");

      this.mediaViewMobile.querySelectorAll(".icon-mode").forEach((element) => {
        var currentColum = parseInt(element.dataset.col);

        if (currentColum == column) {
          element.classList.add("active");
        } else {
          element.classList.remove("active");
        }
      });

      this.initViewModeLayout(column);
    }
  }

  onClickModeButtonMobileHandler(event) {
    event.preventDefault();

    var buttonElement = event.currentTarget,
      viewMode = this.mediaViewMobile?.querySelector(".icon-mode.active"),
      column = parseInt(buttonElement.dataset.col);

    if (!buttonElement.classList.contains("active")) {
      viewMode?.classList.remove("active");
      buttonElement.classList.add("active");

      this.mediaView?.querySelectorAll(".icon-mode").forEach((element) => {
        var currentColum = parseInt(element.dataset.col);

        if (currentColum == column) {
          element.classList.add("active");
        } else {
          element.classList.remove("active");
        }
      });

      this.initViewModeLayout(column);
    }
  }

  initViewModeLayout(column) {
    const productListing = document
      .getElementById("ProductGridContainer")
      .querySelector("#product-grid");

    if (!productListing) return;

    switch (column) {
      case 1:
        productListing.classList.remove(
          "grid--5-col",
          "grid--4-col",
          "grid--3-col",
          "grid--2-col"
        );
        productListing.classList.add("grid--1-col", "product-list-view");

        break;

      default:
        switch (column) {
          case 2:
            productListing.classList.remove(
              "product-list-view",
              "grid--1-col",
              "grid--5-col",
              "grid--4-col",
              "grid--3-col"
            );
            productListing.classList.add("grid--2-col");

            break;
          case 3:
            productListing.classList.remove(
              "product-list-view",
              "grid--1-col",
              "grid--5-col",
              "grid--4-col",
              "grid--2-col"
            );
            productListing.classList.add("grid--3-col");

            break;
          case 4:
            productListing.classList.remove(
              "product-list-view",
              "grid--1-col",
              "grid--5-col",
              "grid--3-col",
              "grid--2-col"
            );
            productListing.classList.add("grid--4-col");

            break;
          case 5:
            productListing.classList.remove(
              "product-list-view",
              "grid--1-col",
              "grid--2-col",
              "grid--3-col",
              "grid--4-col"
            );
            productListing.classList.add("grid--5-col");

            break;
        }
    }
  }
}

customElements.define("view-mode", ViewMode);
